

































import { Component, Vue } from 'vue-property-decorator'
import NotificationsHubContent from '../notifications-hub-content/notifications-hub-content.vue'
import { initialState } from '@/store'
import { getNotificationsCount, getNotificationsStream } from '@/store/notifications/reducer'
import { closeStreams, manageAnalyticsOpen } from '@/services/utils'

@Component({
  name: 'slot-reachme-entry',
  components: {
    NotificationsHubContent,
  },
  props: {
    state: {
      default: initialState,
    },
  },
})
export default class SlotReachmeEntry extends Vue {
  showFlyout = false

  created(): void {
    getNotificationsCount()
    getNotificationsStream()
    window.addEventListener('owc-header-flyout-close', () => (this.showFlyout = false))
  }

  toggleFlyout(): void {
    this.showFlyout = !this.showFlyout
    if (this.showFlyout) manageAnalyticsOpen()
  }

  beforeDestroy(): void {
    window.removeEventListener('owc-header-flyout-close', () => (this.showFlyout = false))
    closeStreams()
  }
}
